function Testimonials() {
  const reviews = [
    {
      quote: "One Stop Greek has revolutionized how we manage study hours. Our chapter's GPA has never been higher.",
      author: "Ben W., Scholarship Chair",
      chapter: "Theta Chi, University of North Texas"
    },
    {
      quote: "The Canvas integration saves us so much time. No more manually verifying grades!",
      author: "Sarah M., Academic VP",
      chapter: "Delta Gamma, Texas A&M University"
    },
    {
      quote: "Finally, an app that actually understands what Greek life needs. The point system is perfect for keeping everyone accountable.",
      author: "Michael R., President",
      chapter: "Sigma Alpha Epsilon, University of Texas"
    }
  ];

  return (
    <section id="testimonials" style={{ backgroundColor: '#F8F9FB' }} className="py-16">
      <div className="container mx-auto px-4">
        {/* Section Title */}
        <h2 className="text-3xl font-bold text-center mb-12 text-gray-900">
          Trusted by Chapters Like Yours
        </h2>

        {/* Review Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {reviews.map((review, index) => (
            <div
              key={index}
              className="bg-white p-6 rounded-lg shadow-lg hover:shadow-xl transition-shadow"
            >
              {/* Quote Icon */}
              <svg
                className="w-10 h-10 mb-4"
                fill="#a60533"
                viewBox="0 0 24 24"
              >
                <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z" />
              </svg>

              {/* Quote */}
              <p className="text-lg italic text-gray-700 mb-4">
                "{review.quote}"
              </p>

              {/* Author */}
              <p className="font-bold text-gray-900 mt-4">
                {review.author}
              </p>

              {/* Chapter */}
              <p className="text-sm text-gray-500">
                {review.chapter}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Testimonials;

